import { Layers } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { appointmentCourseStepPath } from '@/lib/treatmentCoursePatientParams';

export function AppointmentCourseButton({
  patientId,
  courseId,
  stepId,
  onOpen,
}: {
  patientId?: string | null;
  courseId?: string | null;
  stepId?: string | null;
  onOpen: (path: string) => void;
}) {
  const { t } = useTranslation();
  const path = appointmentCourseStepPath({ patientId, courseId, stepId });
  if (!path) return null;

  return (
    <Button
      type="button"
      variant="secondary"
      data-testid="appointment-course-link"
      onClick={() => onOpen(path)}
    >
      <Layers />
      {t('appointments.details.open_course')}
    </Button>
  );
}
